module.exports = __webpack_public_path__ + "img/green.0608f516.svg";